import { render, staticRenderFns } from "./poster-size-slider.vue?vue&type=template&id=2421162a"
import script from "./poster-size-slider.vue?vue&type=script&lang=js"
export * from "./poster-size-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports